import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useMutation } from 'react-query';
import toast from 'react-hot-toast';
import apiService from '../services/api';
import { PasswordResetRequest } from '../types';

interface ForgotPasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ForgotPasswordModal: React.FC<ForgotPasswordModalProps> = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');

  const forgotPasswordMutation = useMutation(
    (data: PasswordResetRequest) => {
      console.log('Отправляем запрос на сброс пароля:', data);
      return apiService.forgotPassword(data);
    },
    {
      onSuccess: (response) => {
        console.log('Успешный ответ:', response);
        toast.success('Инструкции по восстановлению пароля отправлены на ваш email');
        setEmail('');
        onClose();
      },
      onError: (error: any) => {
        console.error('Ошибка при сбросе пароля:', error);
        toast.error(error.detail || 'Ошибка при отправке запроса');
      }
    }
  );

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Обработка отправки формы');
    if (!email.trim()) {
      toast.error('Введите email');
      return;
    }
    console.log('Вызываем мутацию с email:', email.trim());
    forgotPasswordMutation.mutate({ email: email.trim() });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Восстановление пароля</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Введите ваш email"
              required
            />
          </div>

          <div className="mb-6">
            <p className="text-sm text-gray-600">
              Введите email, указанный при регистрации. Мы отправим вам инструкции по восстановлению пароля.
            </p>
          </div>

          <div className="flex space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Отмена
            </button>
            <button
              type="submit"
              disabled={forgotPasswordMutation.isLoading}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {forgotPasswordMutation.isLoading ? 'Отправка...' : 'Отправить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordModal; 